import { Navigate, useLocation, useParams } from "react-router-dom";
import { z } from "zod";

import type { FormSectionCompleteProps } from "@thalamos/vision-common";
import {
  FormSectionSchema,
  IncidentWorkItemIdSchema,
} from "@thalamos/vision-common";

import { FormSectionComplete } from "../../components/FormSectionComplete/FormSectionComplete.js";
import { createRoute } from "../../routing/createRoute.js";

// We don't model the payload's internals here: its shape depends on the section.
const FormSectionCompleteStateSchema = z.object({
  type: FormSectionSchema,
  payload: z
    .custom<NonNullable<FormSectionCompleteProps["payload"]>>()
    .optional(),
}) satisfies z.ZodType<FormSectionCompleteProps>;

export const FormSectionCompletePage = () => {
  const location = useLocation();
  const params = useParams();

  const state = FormSectionCompleteStateSchema.safeParse(location.state);
  if (state.success) {
    return <FormSectionComplete {...state.data} />;
  }

  // Router state belongs to one history entry, so this URL opened afresh (a new
  // tab, a bookmark) has no section to confirm.
  const incidentWorkItemId = IncidentWorkItemIdSchema.safeParse(params.id);
  if (!incidentWorkItemId.success) {
    throw new Error("Invalid incident work item id");
  }

  return (
    <Navigate
      replace
      to={createRoute.incidentProgressPage(incidentWorkItemId.data)}
    />
  );
};
